import React from 'react';

import { createPortal } from 'react-dom';
import './styles.css';

export default function SuccessSubmitModal({ isOpen, onClose, formId, role, formType = "TCE" }) {
  if (!isOpen) return null;

  const isEmpresa = role === 'empresa';
  let modalTitle = `Cadastro enviado com sucesso! (${formType} #${formId})`;
  let modalBody = null;

  if (formType === "TCE") {
    if (isEmpresa) {
      modalBody = (
        <>
          <p>O formulário foi registrado.</p>
          <br />
          <p>O próximo passo é o preenchimento dos dados pelo(a) estagiário(a). Assim que essa etapa for concluída, o processo seguirá para validação do CIEE/MG.</p>
        </>
      );
    } else {
      modalTitle = `Dados enviados com sucesso! (${formType} #${formId})`;
      modalBody = (
        <>
          <p>Suas informações foram registradas e encaminhadas para análise do CIEE/MG.</p>
          <br />
          <p>Você será notificado(a) assim que a validação for concluída.</p>
        </>
      );
    }
  } else if (formType === "TCA" || formType === "TCA Empregador") {
    if (isEmpresa) {
      modalBody = (
        <>
          <p>O formulário foi registrado.</p>
          <br />
          <p>O próximo passo é o preenchimento dos dados pelo(a) aprendiz. Após a conclusão, o cadastro seguirá para validação do CIEE/MG.</p>
        </>
      );
    } else {
      modalTitle = `Dados enviados com sucesso! (${formType} #${formId})`;
      modalBody = (
        <>
          <p>Suas informações foram registradas e enviadas para validação do CIEE/MG.</p>
          <br />
          <p>O processo seguirá para a próxima etapa logo após a conclusão da análise.</p>
        </>
      );
    }
  } else if (formType === "TCA Comum" || formType === "TCA_COMUM") {
    modalBody = (
      <>
        <p>O cadastro foi encaminhado diretamente para validação do CIEE/MG.</p>
        <br />
        <p>Assim que a análise for concluída, o processo avançará para a próxima etapa.</p>
      </>
    );
  } else {
    // Fallback padrão
    if (isEmpresa) {
      modalBody = (
        <>
          <p>O formulário foi registrado.</p>
          <br />
          <p>O próximo passo é o preenchimento dos dados pelo(a) estagiário(a). Após a conclusão, o cadastro seguirá para validação do CIEE/MG.</p>
        </>
      );
    } else {
      modalTitle = `Dados enviados com sucesso! (${formType} #${formId})`;
      modalBody = (
        <>
          <p>Suas informações foram registradas e enviadas para validação do CIEE/MG.</p>
          <br />
          <p>O processo seguirá para a próxima etapa logo após a conclusão da análise.</p>
        </>
      );
    }
  }

  return createPortal(
    <div className="success-modal-overlay" onClick={onClose}>
      <div className="success-modal-card" onClick={(e) => e.stopPropagation()}>
        <div className="success-modal-header">
          <div className="success-modal-icon-box">
            <svg
              width="32"
              height="32"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#10b981"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
              <polyline points="22 4 12 14.01 9 11.01"></polyline>
            </svg>
          </div>
          <h2 className="success-modal-title">
            {modalTitle}
          </h2>
        </div>
        
        <div className="success-modal-body">
          {modalBody}
        </div>

        <div className="success-modal-actions">
          <button type="button" className="success-modal-btn" onClick={onClose}>
            Entendi
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
